import { Badge } from "@/components/ui/badge";
import moment from "moment";
import obterRespostaByArray from "@/utils/obterRespostaByArray";
import getServico from "@/utils/getServico";
import getSetor from "@/utils/getSetor";
import { ScrollArea } from "@/components/ui/scroll-area";
import { formatarNome } from "@/utils/formatarNome";
import { TooltipEasy } from "@/components/tooltipEasy";
import { MapPin, User, UserCheck } from "lucide-react";
import { ItemAtendente } from "./ItemAtendente";
import { StatusIndicator } from "./StatusIndicator";
import getPrazo from "@/utils/getPrazo";
import { EmptyData } from "./EmptyData";

export function CardAtendente({ atendente, total_finalizados, total_andamento, ultimo_registro, solicitacoes, unidade,unidadeId, ultimo_registro_toISOString }) {

  if (solicitacoes?.length === 0) return <div className="hidden" />

  return (
    <div className="relative bg-[#f3f4f5] rounded-md min-h-[500px] max-h-[500px] border border-[#e2e8f0]">
      <div className="flex items-center gap-1 absolute top-2 right-2">
        <TooltipEasy content="Quantidade de finalizados com esse agente"><Badge className="bg-emerald-600 text-white">{total_finalizados} <UserCheck /></Badge></TooltipEasy>
        <TooltipEasy content="Quantidade com esse agente"><Badge className="bg-[#717171] text-white">{total_andamento} <User /></Badge></TooltipEasy>
      </div>
      <div className="mt-4 p-4">
        <p className="font-bold text-base w-full truncate">{formatarNome(atendente)}</p>
        <div className="flex items-center gap-1">
          <StatusIndicator ultimo_registro={ultimo_registro_toISOString} />
          <p className="text-[12px]">{ultimo_registro ? `Último atendimento ${ultimo_registro}` : "Sem último atendimento"}</p>
        </div>
        <div className="flex items-center gap-1 mt-1">
          <MapPin className="size-3" />
          <p className="text-[12px] font-medium">{unidade}</p>
        </div>
      </div>

      <ScrollArea className="h-[378px] px-4">
        <div className="flex flex-col gap-2">
          {solicitacoes?.length === 0 && <EmptyData />}
          {solicitacoes.map(item => (
            <ItemAtendente
              key={item._id}
              id={item._id}
              tempo_ate_agora={moment(item.createdAt).fromNow()}
              nome_aluno={obterRespostaByArray(item.solicitacao, "nome_completo")}
              servico={getServico(item.setor, item.servico)}
              setor={getSetor(item.setor)}
              setorId={item.setor}
              servicoId={item.servico}
              prazo={getPrazo(item.setor, item.servico)}
              createdAt={item.createdAt}
              unidadeId={unidadeId}
            />
          ))}
        </div>
      </ScrollArea>

    </div>
  )
}